
/* injects from baggage-loader */
require('./style.scss');

import React from "react";
import { connect } from "react-redux";
import { t } from "../../../helpers/translator";
import { ClosePopup } from "../../../actions/ui";
import placeCardPic from '../../../images/placeCard.png';

const DepositMoneyPlaceCard = (props) => { 
    return (
        <div className='place-card-container'>
            <p className='place-card-title'>{t("Deposit by bank card")}</p>
            <p className='place-card-sub-title'>{t("Please place your bank card to the POS Device and click on confirm button")}</p>
            {/* < div><CountDownComponent second={60} sendEventToBack={false} /></div> */}
            <img alt='place-card' src={placeCardPic}/>
            <button
                className='button-view-normal-m cancel'
                onClick={() => props.dispatch(ClosePopup())}
            >
                Cancel
            </button>
        </div>
    )
}

export default connect()(DepositMoneyPlaceCard)